import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { ButtonRound } from "@/components/basic/Buttons";

const ThreeDSAuth = () => {
  const { search } = useLocation();
  const formRef = useRef() as React.MutableRefObject<HTMLFormElement>;

  const query: any = useMemo(() => queryString.parse(search), [search]);

  useEffect(() => {
    if (query?.ACSURL) {
      formRef?.current?.submit();
    }
  }, [query]);

  return query?.ACSURL ? (
    <form action={query.ACSURL} method="post" ref={formRef} className="mt-10">
      {query?.VPSTxId ? (
        <>
          <input type="hidden" name="creq" value={query.CReq || ""} />
          <input
            type="hidden"
            name="threeDSSessionData"
            value={query.VPSTxId || ""}
          />
        </>
      ) : (
        <>
          <input type="hidden" name="MD" value={query.MD || ""} />
          <input type="hidden" name="PaReq" value={query.PaReq || ""} />
          <input type="hidden" name="TermUrl" value={query.TermUrl || ""} />
        </>
      )}
      <h4>
        We need to connect to your card issuer to verify this transaction.
      </h4>
      <p>Please click the button below to Authenticate your card</p>
      <ButtonRound
        buttonType="submit"
        text="Go"
        type="success"
        className="h-10 mt-3 three-ds-auth-btn"
      ></ButtonRound>
    </form>
  ) : (
    <></>
  );
};

export { ThreeDSAuth };
